import styled from "styled-components";

const HomeExtortionWrap = styled.div`
background: linear-gradient(to top,#ffffff,#f6f6f6);
padding: 32px 0 0 0;
`

export default HomeExtortionWrap